
import React, { createContext, useContext } from "react";
import { useAuth, AuthContextProps } from "react-oidc-context";

const SessionContext = createContext<AuthContextProps | null>(null);

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const auth = useAuth();

  return (
    <SessionContext.Provider value={auth}>{children}</SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used within a SessionProvider");
  }
  return context;
};
